var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement } from "lit/decorators.js";
import { LitElement } from "lit";
import { modalController } from "@ionic/core/components";
import { eventManager } from "../../decorators/event.js";
const IMAGE_LINK_SELECTOR = "a[href$=jpg], a[href$=jpeg], a[href$=png], a[href$=gif], a[href$=webp], a[href$=svg], a[href$=bmp]";
/**
 * Show images from children's a[href] in a lightbox.
 *
 * @example
 *
 * <image-lightbox>
 *   <a href="https://picsum.photos/2000/3000.jpg">
 *     <img src="https://picsum.photos/200/300.jpg" />
 *   </a>
 *   <a href="https://picsum.photos/2000/3000.jpg">
 *     <img src="https://picsum.photos/200/300.jpg" />
 *   </a>
 * </image-lightbox>
 */
let ImageLightbox = class ImageLightbox extends LitElement {
    constructor() {
        super(...arguments);
        this.handleImageLinkClick = (event) => {
            event.preventDefault();
            const clickedIndex = Array.from(this.querySelectorAll(IMAGE_LINK_SELECTOR)).findIndex((a) => a.href === event.currentTarget.href);
            this.presentModal(clickedIndex !== -1 ? clickedIndex : 0);
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.ev.binds(this, {
            [IMAGE_LINK_SELECTOR]: [["click", this.handleImageLinkClick]],
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.ev.removeListeners();
    }
    createRenderRoot() {
        return this;
    }
    async presentModal(startIndex = 0) {
        await import("./image-lightbox-modal.js");
        const modal = await modalController.create({
            component: "image-lightbox-modal",
            componentProps: {
                imageUrls: this.imageUrls,
                startIndex,
            },
            cssClass: "image-lightbox-modal",
        });
        await modal.present();
    }
    get imageUrls() {
        return Array.from(this.querySelectorAll(IMAGE_LINK_SELECTOR)).map((link) => link.href);
    }
};
__decorate([
    eventManager()
], ImageLightbox.prototype, "ev", void 0);
ImageLightbox = __decorate([
    customElement("image-lightbox")
], ImageLightbox);
export default ImageLightbox;
//# sourceMappingURL=image-lightbox.js.map